<mf-form
  [formGroup]="collectOrderForm"
  [entity]="collectOrderDto"
  (save)="save.emit($event)"
  (closeButtonClick)="close.emit()"
  [closeButtonShow]="true">
  <mf-column-display label="Cliente">
    {{ collectOrderDto.operation.client.name }}
  </mf-column-display>

  <mf-column-display label="Motivo de la Operación">
    {{ collectOrderDto.operation.reason }}
  </mf-column-display>

  <mf-column-display label="Monto">
    {{ collectOrderDto.operation.currency | customCurrency }} {{ collectOrderDto.operation.amount }}
  </mf-column-display>

  <mf-column [md]="4">
    <mf-field-text formControlName="externalId" />
  </mf-column>

  <mf-column [md]="4">
    <mf-autocomplete-person
      formControlName="person"
      (itemIdChanged)="onPersonSelected($event)" />
  </mf-column>

  <mf-column [md]="4">
    <mf-field-numeric formControlName="amount" />
  </mf-column>

  <mf-column [md]="12">
    <mf-field-text formControlName="reference" />
  </mf-column>
</mf-form>
